import React from 'react';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import classes from './CustomerInfo.module.scss';
import { AvatarIcon, Point } from '../../../../../../shared/components/ui-components';
import { scanIqCustomerProfileStore } from '../../../../../stores/scanIqCustomerProfileStore';
import { calculateFullYears } from '../../../../../../shared/utils/dateUtils';
import { CustomerStatus } from './CustomerStatus/CustomerStatus';

const CustomerInfo = observer(() => {
  const { customerProfileInfo } = scanIqCustomerProfileStore;

  if (!customerProfileInfo) {
    return null;
  }

  const { personalData } = customerProfileInfo;

  return (
    <div className={classes.container}>
      <AvatarIcon
        size="large"
        userName={personalData.firstName}
        className="private-info"
      />
      <div className={classes.customerInfo}>
        <p className={classNames(classes.customerName, 'private-info')}>
          {personalData.firstName} {personalData.lastName}
        </p>
        <div className={classes.additionalInfo}>
          <p>
            {personalData.gender}, {calculateFullYears(personalData.dateOfBirth)} years
          </p>
          <Point />
          <CustomerStatus />
        </div>
      </div>
    </div>
  );
});

export { CustomerInfo };
